import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {LoadingService} from "../loading/loading.service";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {catchError, Observable, tap, throwError} from "rxjs";
import {AppMessageService} from "../app-message/app-message.service";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private readonly baseURL = environment.apiUrl;
  private readonly headers = {};

  constructor(private readonly http: HttpClient, private readonly loadingService: LoadingService, private readonly appMessageService: AppMessageService) {
    this.headers = {'Accept-Language': 'tr'};
  }

  post<T>(
    apiUrl: string,
    body: { [key: string]: any } | FormData = {},
    loaderConfig = {showLoader: true, message: 'Loading...'},
    headers: { [key: string]: string } = {...this.headers}): Observable<T> {

    if (loaderConfig.showLoader) {
      this.presentLoading(loaderConfig.message);
    }
    return this.http.post<T>(`${this.baseURL}${apiUrl}`, body, {
      headers
    }).pipe(tap((response) => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleResponse(response);
    }), catchError(err => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleError(err);
      return throwError(()=> err);;
    }));
  }

  postCustom(
    apiUrl: string,
    body: { [key: string]: any } | FormData = {},
    loaderConfig = {showLoader: true, message: 'Loading...'},
    headers: any) {

    if (loaderConfig.showLoader) {
      this.presentLoading(loaderConfig.message);
    }

    const header = new HttpHeaders({
      Authorization:
        'Basic ' +
        btoa(`${environment.callActionApiUser}:${environment.callActionApiPassword}`),
      'Content-Type': 'application/json',
    });
    return this.http.post(`${apiUrl}`, body, {
      headers: header
    }).pipe(tap((response) => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleResponse(response);
    }), catchError(err => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleError(err);
      return throwError(()=> err);;
    }));
  }

  get<T>(
    apiUrl: string,
    parameters?: { [key: string]: string },
    loaderConfig: { showLoader: boolean; message?: string } = {showLoader: true, message: 'Loading...'},
    headers: { [key: string]: string } = {}): Observable<T> {
    if (loaderConfig.showLoader) {
      this.presentLoading(loaderConfig?.message);
    }
    const params = new HttpParams({fromObject: parameters});
    return this.http.get<T>(`${this.baseURL}${apiUrl}`, {
      params,
      headers
    }).pipe(tap((response) => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleResponse(response);
    }), catchError(err => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleError(err);
      return throwError(()=> err);;
    }));
  }


  getFilter<T>(
    apiUrl: string,
    parameters: { event: any, filter: any },
    loaderConfig: { showLoader: boolean; message?: string } = {showLoader: true, message: 'Loading...'},
    headers: { [key: string]: string } = {}): Observable<T> {

    if (loaderConfig.showLoader) {
      this.presentLoading(loaderConfig?.message);
    }


    const queryStr = Object.keys(parameters.filter).map(el => {
      let filterString = parameters.filter[el];
      if (filterString || filterString === false) {
        if (parameters.filter[el] && parameters.filter[el].length > 0 && typeof parameters.filter[el] == 'object') {
          const filterBy = parameters.filter[el];
          filterString = Object.values(filterBy).map(el => (`${el}`)).join(",")
        }
        if (el?.includes('startDateRange') || el?.includes('endDateRange')) {
          el = "filter.date";
        }
        if (Array.isArray(filterString)) {
          if (filterString.length === 0) {
            return '';
          }
          return `${el}=${filterString.join(',')}`;
        }
        return `${el}=${filterString}`;
      }
      return null
    }).join("&");

    parameters.event.first = parameters?.event?.first / parameters?.event?.rows + 1;
    const paginateStr = new URLSearchParams(({
      page: parameters?.event?.first,
      limit: parameters?.event?.rows,
      sortBy: parameters?.event?.sortField ? (`${parameters.event.sortField}${(parameters.event.sortOrder == 1) ? ':ASC' : ':DESC'}`) : '',
    }));

    return this.http.get<T>(`${this.baseURL}${apiUrl}?${queryStr}&${paginateStr}`, {
      headers
    }).pipe(tap((response) => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleResponse(response);
    }), catchError(err => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleError(err);
      return throwError(()=> err);;
    }));
  }

  put<T = any>(
    apiUrl: string,
    body: { [key: string]: any } | FormData = {},
    loaderConfig = {showLoader: true, message: 'Loading...'},
    headers: { [key: string]: string } = {}): Observable<T> {

    if (loaderConfig.showLoader) {
      this.presentLoading(loaderConfig.message);
    }
    return this.http.put<T>(`${this.baseURL}${apiUrl}`, body, {
      headers
    }).pipe(tap((response) => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleResponse(response);
    }), catchError(err => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleError(err);
      return throwError(()=> err);;
    }));
  }

  patch<T = any>(
    apiUrl: string,
    body: { [key: string]: any } | FormData = {},
    loaderConfig = {showLoader: true, message: 'Loading...'},
    headers: { [key: string]: string } = {}): Observable<T> {

    if (loaderConfig.showLoader) {
      this.presentLoading(loaderConfig.message);
    }
    return this.http.patch<T>(`${this.baseURL}${apiUrl}`, body, {
      headers
    }).pipe(tap((response) => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleResponse(response);
    }), catchError(err => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleError(err);
      return throwError(()=> err);;
    }));
  }

  delete<T = any>(
    apiUrl: string,
    parameters?: { [key: string]: any },
    loaderConfig: { showLoader: boolean; message?: string } = {showLoader: true, message: 'Loading...'},
    headers: { [key: string]: string } = {}): Observable<T> {
    if (loaderConfig.showLoader) {
      this.presentLoading(loaderConfig.message);
    }
    const params = new HttpParams({fromObject: parameters});
    return this.http.delete<T>(`${this.baseURL}${apiUrl}`, {
      params,
      headers
    }).pipe(tap((response) => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleResponse(response);
    }), catchError(err => {
      if (loaderConfig.showLoader) {
        this.loadingService.hide();
      }
      this.HandleError(err);
      return throwError(()=> err);;
    }));
  }

  HandleError(error: any) {
    if(error?.code=='ENOTFOUND'){
      this.appMessageService.errorToast(
        '',
        'Connector Network Error',
        20000,
        'top-right'
      );
    }
    if (error?.error?.errors) {
      let errorMessage = "";
      for(const err of error.error.errors){
        for(const values of  Object.entries(err.constraints)){
          errorMessage += `${err.property} ${values[1]}` + '\n';

        }
      }
      this.appMessageService.errorToast(
        error.error.message,
        errorMessage,
        20000,
        'top-right'
      );
    } else if (error?.errors?.length > 0) {
      let errorMessage = "";
       for(const err of error.error.errors){
        for(const value of err.constraints){
            errorMessage += `${value}\n`;
        }
      }

      // Hata mesajını göstermek için toast
      this.appMessageService.errorToast(
        "Validation Error",
        errorMessage || "Bir hata oluştu.",
        20000,
        "top-right"
      );
    } else if (typeof error?.error?.error == 'string') {
      this.appMessageService.errorToast(
        '',
        error.error.error,
        20000,
        'top-right'
      );
    } else if (error?.statusCode) {
      this.appMessageService.errorToast(
        error?.error,
        error?.message,
        20000,
        'top-right'
      );
    }
  }

  HandleResponse(response: any) {
    if (response?.Status === 500) {
      alert(response);
    }
  }

  async presentLoading(message?: string) {
    this.loadingService.show({
      message,
      spinner: 'bubbles'
    });
  }
}
